/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { TabComponent } from './tab.component';

@Component({
  selector: 'ut-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  standalone: false,
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;
  @Output() tabChange = new EventEmitter<string>();
  @Input() activeTabId?: string;

  ngAfterContentInit(): void {
    // Set first tab as active if no active tab specified
    if (!this.activeTabId && this.tabs.length > 0) {
      const firstTab = this.tabs.first;
      if (firstTab) {
        firstTab.active = true;
        this.activeTabId = firstTab.tabId;
      }
    } else if (this.activeTabId) {
      // Activate the specified tab
      this.selectTab(this.activeTabId);
    }
  }

  selectTab(tabId: string, emitEvent = false): void {
    // Deactivate all tabs
    this.tabs.forEach((tab) => {
      tab.active = false;
    });

    // Activate selected tab
    const selectedTab = this.tabs.find((tab) => tab.tabId === tabId);
    if (selectedTab) {
      selectedTab.active = true;
      this.activeTabId = tabId;

      if (emitEvent) {
        this.tabChange.emit(tabId);
      }
    }
  }

  onTabClick(tabId: string): void {
    this.selectTab(tabId, true);
  }
}
